<template>
  <div>
    <vxe-grid
      ref="table"
      row-id="fabricCode"
      size="small"
      rsound
      auto-resize
      highlight-hover-row
      :height="570"
      :loading="loading"
      :data="tableData"
      :columns="tableColumns"
      :toolbar-config="{ slots: { buttons: 'toolbar_form' } }"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
      :radio-config="
        !multiple ? { trigger: 'row', highlight: true, reserve: true } : {}
      "
      :checkbox-config="
        multiple ? { trigger: 'row', highlight: true, reserve: true } : {}
      "
      :edit-config="{ trigger: 'click', mode: 'row' }"
      :edit-rules="validRules"
      @cell-click="onCellClick"
      @radio-change="radioChange"
      @checkbox-change="checkboxChange"
      @checkbox-all="checkboxChange"
    >
      <template v-slot:toolbar_form>
        <slot name="header"> </slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:displayImage="{ row: { defaultImageUrl } }">
        <el-image
          :src="defaultImageUrl || '/image/static/img/nopic.jpg'"
          :preview-src-list="[defaultImageUrl || '/image/static/img/nopic.jpg']"
          style="width: 100px; height: 66px"
          fit="cover"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:fabricName="{ row }">
        <span>{{ row.fabricName }}</span>
        <br />
        <span>{{ row.fabricNameEn }}</span>
      </template>
      <template v-slot:fabricContent="{ row }">
        <span>{{ row.fabricContent }}</span>
        <br />
        <span>{{ row.fabricContentEn }}</span>
      </template>
      <template v-slot:wid="{ row }">
        <span>{{ row.wid }} </span>
        <span>{{ row.widUnit }}</span>
      </template>
      <template v-slot:fabricWeight="{ row }">
        <span>{{ row.fabricWeight }} </span>
        <span>{{ row.fabricWeightUnit }}</span>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-1">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
export default {
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
  },
  watch: {
    tableData: {
      handler(e) {
        if (!e || !e.length) return
        this.v_tableData = e
        this.v_tableData.forEach((f) => (f.generateQuantity = 1))
      },
      immediate: true,
    },
  },
  data() {
    return {
      tableColumns: tableColumns(this),
      v_tableData: [],
      validRules: {
        generateQuantity: [
          {
            type: 'number',
            required: true,
            trigger: 'blur',
            pattern: /([1-9]\d*(\.\d*[1-9])?)|(0\.\d*[1-9])/,
            message:
              this.$l('tips_number_must_be_greater_than_0') ||
              '生成数量须大于0',
          },
        ],
      },
    }
  },
  methods: {
    checkboxChange({ records, reserves }) {
      this.$emit('choose-change', records.concat(reserves))
    },
    radioChange({ row }) {
      this.$emit('choose-change', row)
    },
    // 避免点击操作列也会选择行
    onCellClick({ row, column }) {
      const { property } = column
      const filterColumns = ['generateQuantity']
      if (!filterColumns.includes(property)) return

      const $table = this.$refs.table
      $table.toggleCheckboxRow(row)
      const data = $table.getCheckboxRecords(true)
      const reserves = $table.getCheckboxReserveRecords(true)
      this.$emit('choose-change', data.concat(reserves))
    },
    async validEvent() {
      const result = await this.$refs.table.validate(true).catch(() => true)
      return !result
    },
  },
}
</script>
